import styles from '@features/cms/components/collections/ProductPremiumBlock/components/ProductPremiumPagination/ProductPremiumPagination.styles';
type PropsType = {
  blocksCount: number;
  activeBlock: number;
};
const ProductPremiumPagination = ({
  blocksCount,
  activeBlock
}: PropsType) => <div sx={styles.paginationContainer}>
    {[...Array(blocksCount)].map((_, index) => <div key={`productPremiumPagination${Math.random()}`} sx={styles.paginationBlock(index === activeBlock)} />)}
  </div>;
export default ProductPremiumPagination;